import { render } from "./SamlBindingEditor.vue?vue&type=template&id=471ce8a3&scoped=true&lang=pug"
import script from "./SamlBindingEditor.vue?vue&type=script&lang=js"
export * from "./SamlBindingEditor.vue?vue&type=script&lang=js"

import "./SamlBindingEditor.vue?vue&type=style&index=0&id=471ce8a3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471ce8a3"]])

export default __exports__